<template>
  <div class="row">
    
    <div class="col-lg-12 text-center table-responsive">
      <Chart
        :size="{ width: width, height: height }"
        :data="data"
        :margin="margin"
        :direction="direction"
        :axis="axis">

        <template #layers>
          <Grid strokeDasharray="1,1" />
          <Bar v-for="(field,key) in chart_fields" :dataKeys="['this_month',key]" :barStyle="{ fill: field.color }" />
        </template>

        <template #widgets>
          <Tooltip
            borderColor="#48CAE4"
            :config="chart_config"
          />
        </template>

      </Chart>

      <div class="mt-3">
        <span v-for="(field,key) in chart_config">
          <span v-if="field.hide==false && key!=field.fkey">
            <span class="fa fa-square px-1" :style="{'color':field.color}"></span>
            <span class="text-bold" :style="{'color':field.color}">{{field.label}}</span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, watch } from 'vue'
import { Chart, Grid, Bar, Tooltip } from 'vue3-charts'

export default defineComponent({
  props:{
    width   : Number,
    height  : Number
  },
  components: { Chart, Grid, Bar, Tooltip },
  mounted(){
    var new_data    = [];
    
    for (var i = 0; i < (this.$parent.clicks_summary).length; i++)
    {
      
      var entry = (this.$parent.clicks_summary)[i];
    
      for (const [key, value] of Object.entries(entry))
      {
        if(entry.first_field==key || key=='first_field')
        {
          entry[key] = value.toString();
        }else
        {
          entry[key] = parseFloat(value);
        }
        
      }

      //get fields and configs
      if(i==0)
      {
        var fkey      = entry.first_field;
        var cnt       = 0;
        for (const [key, value] of Object.entries(entry))
        {
          var config        = {};
          var fields        = {};
          var is_hide       =  false;
          var label = key.split('_');

          for (var j = 0; j < label.length; j++) {
            label[j] = (label[j].charAt(0)).toUpperCase() + (label[j]).substr(1);
          }

          label = label.join(" ");

          if(entry.first_field!=key && key!='first_field')
          {
            fields[key] = {
                          fkey      : fkey,
                          color     : this.colors[cnt]
                        }
            Object.assign(this.chart_fields,fields);

          }

          if(key=='first_field')
          {
            is_hide =  true;
          }

          config[key] = {
                          fkey      : fkey,
                          color     : this.colors[cnt],
                          label     : label,
                          hide      : is_hide
                        }

          Object.assign(this.chart_config,config);
          
          cnt++;
        }
      }

      new_data.push(entry);
    }

    this.data = new_data;
    
  },
  setup() {

    const colors = reactive({
                    0 : '#25b673',
                    1 : '#ffc107',
                    2 : '#fd7e14',
                    3 : '#dc2626',
                    4 : '#0dcaf0',
                    5 : '#0d6efd',
                    6 : '#22844b'
                  });

    const data = ref();
    const direction = ref('horizontal')
    const margin = ref({
      left: 0,
      top: 20,
      right: 20,
      bottom: 0
    })

    const axis = ref({
      primary: {
        type: 'band'
      },
      secondary: {
        domain: ['dataMin', 'dataMax + 100'],
        type: 'linear',
        ticks: 5
      }
    })

    const chart_fields = reactive({});
    const chart_config = reactive({});

    const getData = (new_data) => {
      
      var new_entry = [];

      for (var i = 0; i < new_data.length; i++)
      {
        
        var entry = new_data[i];

        for (const [key, value] of Object.entries(entry)) {
          if(entry.first_field==key || key=='first_field')
          {
            entry[key] = value.toString();
          }else
          {
            entry[key] = parseFloat(value);
          }
        }

        //get fields and configs
        if(i==0)
        {
          var fkey      = entry.first_field;
          var cnt       = 0;
          for (const [key, value] of Object.entries(entry))
          {
            var config        = {};
            var fields        = {};
            var is_hide       =  false;
            var label = key.split('_');

            for (var j = 0; j < label.length; j++) {
              label[j] = (label[j].charAt(0)).toUpperCase() + (label[j]).substr(1);
            }

            label = label.join(" ");

            if(entry.first_field!=key && key!='first_field')
            {
              fields[key] = {
                            fkey      : fkey,
                            color     : colors[cnt]
                          }
              Object.assign(chart_fields,fields);

            }

            if(key=='first_field')
            {
              is_hide =  true;
            }

            config[key] = {
                            fkey      : fkey,
                            color     : colors[cnt],
                            label     : label,
                            hide      : is_hide
                          }

            Object.assign(chart_config,config);
            
            cnt++;

          }
        }

        new_entry.push(entry);
      }
      
      data.value = new_entry;
     
    }


    return { colors, data, getData, direction, margin, axis, chart_fields, chart_config }
  }
})
</script>